<template>
    <b-modal
        ref="newFormModal"
        title="New Form"
        :ok-only="true"
        @ok="makeNewForm()"
    >
        <div class="form-group">
            <label for="category">Form Category:</label>
            <select
                name="category"
                id="category"
                class="form-control"
                v-model="typeCategory"
            >
                <option>
                    All Forms
                </option>
                <option>
                    Fire Alarm Forms
                </option>
                <option>
                    Exclude Fire Alarm Forms
                </option>
            </select>
        </div>
        <div class="form-group">
            <label for="type">Form Type:</label>
            <select
                name="type"
                id="type"
                class="form-control"
                v-model="newFormType"
            >
                <option
                    v-for="type in formTypes"
                    :key="type.value"
                    :value="type.value"
                >
                    {{ type.name }}
                </option>
            </select>
        </div>
    </b-modal>
</template>

<script>
import * as Form from "../../include/Form";

export default {
    props: {
        params: {
            type: Object,
            default: function () {
                return {};
            },
        },
        route: {
            type: String,
            default: function () {
                return 'office'
            }
        },
    },
    data: function () {
        return {
            newFormType: Form.types[0].value,
            typeCategory: 'All Forms',
        };
    },

    computed: {
        formTypes() {
            return Form.types.filter(t => {
                if (
                    this.$route.path.includes('/engineer')
                    && t.hideFromEngineer
                ) {
                    return false;
                }

                if (this.typeCategory === 'Fire Alarm Forms') {
                    return t.category && t.category === 'fire_alarm';
                }

                if (this.typeCategory === 'Exclude Fire Alarm Forms') {
                    return !t.category || t.category !== 'fire_alarm';
                }

                return true;
            });
        },
    },

    watch: {
        typeCategory: function() {
            if (!this.formTypes.find(t => t.value === this.newFormType)) {
                this.newFormType = this.formTypes[0].value;
            }
        },
    },

    methods: {
        show: function () {
            this.$refs.newFormModal.show();
        },

        makeNewForm: function() {
            this.params.type = this.newFormType;
            if (this.route === 'engineer') {
                this.$router.push({
                    name: 'engineer.forms.new',
                    query: this.params,
                });
            } else {
                this.$router.push({
                    name: 'office.forms.new',
                    query: this.params,
                });
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/NewFormModal.vue